<button mat-flat-button color="primary" (click)="openDialog()" [disabled]="hasSampleBeenRequested">
  {{ dialogButtonText }}
</button>

<ng-template #dialogTemplate>
  <form class="order-sample-form" [formGroup]="form" (ngSubmit)="submit()">
    <h2 mat-dialog-title>Muster anfragen</h2>
    <mat-dialog-content>
      <p>
        <b>Lieferadresse</b>
      </p>

      <div class="form-grid">
        <mat-form-field appearance="outline">
          <mat-label>Firma</mat-label>
          <input matInput [formControlName]="ORDER_FIELDS.COMPANY" />
          @if (form.get(ORDER_FIELDS.COMPANY)?.hasError('required')) {
            <mat-error>Pflichtfeld</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Name</mat-label>
          <input matInput [formControlName]="ORDER_FIELDS.NAME" />
          @if (form.get(ORDER_FIELDS.NAME)?.hasError('required')) {
            <mat-error>Pflichtfeld</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Straße</mat-label>
          <input matInput [formControlName]="ORDER_FIELDS.STREET" />
          @if (form.get(ORDER_FIELDS.STREET)?.hasError('required')) {
            <mat-error>Pflichtfeld</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>PLZ</mat-label>
          <input matInput [formControlName]="ORDER_FIELDS.ZIP" />
          @if (form.get(ORDER_FIELDS.ZIP)?.hasError('required')) {
            <mat-error>Pflichtfeld</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Ort</mat-label>
          <input matInput [formControlName]="ORDER_FIELDS.CITY" />
          @if (form.get(ORDER_FIELDS.CITY)?.hasError('required')) {
            <mat-error>Pflichtfeld</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Land</mat-label>
          <input matInput [formControlName]="ORDER_FIELDS.COUNTRY" />
          @if (form.get(ORDER_FIELDS.COUNTRY)?.hasError('required')) {
            <mat-error>Pflichtfeld</mat-error>
          }
        </mat-form-field>
      </div>

      <br />
      <p>
        Bitte verfassen Sie eine kurze Nachricht an das Start-up und teilen diesem mit,
        <b>welches Produkt bzw. welche Sorte und in welcher Menge</b> Sie Muster anfragen möchten.
      </p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nachricht</mat-label>
        <textarea matInput [formControlName]="ORDER_FIELDS.MESSAGE" rows="6" cdkTextareaAutosize cdkAutosizeMinRows="6" maxlength="2500"></textarea>
        <mat-hint align="end">{{ form.get(ORDER_FIELDS.MESSAGE)?.value?.length || 0 }} / 2500</mat-hint>
        @if (form.get(ORDER_FIELDS.MESSAGE)?.hasError('required')) {
          <mat-error>Pflichtfeld</mat-error>
        }
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-flat-button color="primary" type="button" (click)="closeDialog()">Abbrechen</button>
      <button mat-flat-button color="warn" type="submit" [disabled]="form.invalid || isSubmitting">Absenden</button>
    </mat-dialog-actions>
  </form>
</ng-template>
